<div id="multi-select-root">
  <mat-form-field
    id="multi-select-form-field"
    class="multi-select-form-field"
    appearance="fill"
  >
    <mat-select
      id="multi-select"
      [formControl]="formControl"
      [multiple]="isMultiselector"
      [panelClass]="'selector-panel'"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (closed)="onClosed()"
      (selectionChange)="onSelectionChange($event)"
      disableOptionCentering
    >
      <mat-select-trigger
        *ngIf="isMultiselector"
        [ngStyle]="{ color: isBluePlaceholder() ? 'blue' : 'inherit' }"
        id="multi-select-trigger"
      >
        {{ getMultiSelectorPlaceholder() }}
      </mat-select-trigger>
      <!-- Select-all row (shown only when enabled) -->
      <mat-option
        *ngIf="isMultiselector && showSelectAll"
        class="select-all-option"
        [value]="SELECT_ALL"
        (onSelectionChange)="onSelectAllOptionChange($event)"
        [class.mat-mdc-option-selected]="selectAllChecked"
      >
        <mat-icon *ngIf="selectAllChecked">check_box</mat-icon>
        <mat-icon *ngIf="!selectAllChecked && isIndeterminate"
        >indeterminate_check_box</mat-icon
        >
        <mat-icon *ngIf="!selectAllChecked && !isIndeterminate"
        >check_box_outline_blank</mat-icon
        >

        <span class="ml-2">{{ selectAllLabel }}</span>
      </mat-option>

      <mat-option
        *ngFor="let option of options"
        [value]="option.value"
        id="multi-select-option"
      >
        {{ option.label }}
      </mat-option>
    </mat-select>
    <mat-icon matSuffix>expand_more</mat-icon>
  </mat-form-field>
</div>
